/* @flow */
import BlockedUsers from 'collections/BlockedUsers';
import { ActionTypes } from 'constants/BlockedUserConstants';
import { dispatcher } from 'lib/Dispatcher';

const BlockedUserActions = {
  load(): void {
    BlockedUsers.load().then(blockedUsers => {
      dispatcher.dispatch({
        type: ActionTypes.LOAD_BLOCKED_USERS,
        blockedUsers,
      });
    }).catch(e => console.error('BlockedUsers load failed', e));
  },
};

export default BlockedUserActions;



// WEBPACK FOOTER //
// ./src/actions/BlockedUserActions.js